export default "__VITE_ASSET__cfcaaff0__"